import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faLock, faSignOutAlt, faCog, faThLarge, faBars, faTrash, faEye, faEyeSlash, faUsers, faEdit, faInfo, faCookie, faPrint, faObjectGroup
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, faLock, faSignOutAlt, faCog, faGithub, faThLarge, faBars, faTrash, faEye, faEyeSlash, faEdit, faUsers, faInfo, faCookie, faPrint, faObjectGroup
)

Vue.component('fa', FontAwesomeIcon)
